import { render, staticRenderFns } from "./DNSTwisterWatchlistAvailable.vue?vue&type=template&id=8554ae12&"
import script from "./DNSTwisterWatchlistAvailable.vue?vue&type=script&lang=js&"
export * from "./DNSTwisterWatchlistAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports